// Exposes jQuery on window *before* anything else in application.js gets a
// chance to run -- deliberately its own module, not inline code in
// application.js. ES modules fully execute every one of a file's own
// `import`s before any of that file's own top-level statements run, no
// matter where those statements appear relative to the imports textually.
// So `import "bootstrap-toggle"` (which needs window.jQuery at its own
// top-level, on import) was running to completion -- and throwing --
// *before* application.js's own `window.jQuery = jquery` line ever got a
// chance to execute, since that's just a plain statement in application.js
// itself, gated behind every one of application.js's own imports finishing
// first. Importing this module instead means the assignment happens as
// *this* module's own top-level code, which completes in full before
// application.js's import list moves on to the next entry.
import jquery from "jquery"
window.jQuery = window.$ = jquery
